import { css } from '@emotion/react';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const FormPageContainer = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      css={css`
        padding-top: ${theme.spacing(10)};
        padding-bottom: ${theme.spacing(10)};
        ${theme.breakpoints.down('sm')} {
          padding-top: ${theme.spacing(5)};
          padding-bottom: ${theme.spacing(5)};
        }
      `}
    >
      <div
        css={css`
          width: 100%;
          max-width: 384px;
        `}
      >
        {children}
      </div>
    </Box>
  );
};

FormPageContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormPageContainer;
